import { Scrollbars as ReactScrollbar } from 'react-custom-scrollbars-2';
import { createUseStyles } from 'react-jss';
import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';

const useStyles = createUseStyles({
  scrollbarContainer: {
    // Hide native scrollbars completely in RTL mode
    '[dir="rtl"] &': {
      '& > div:first-child': {
        // Target the view container
        marginLeft: '0 !important',
        marginRight: '0 !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
        right: '0 !important',
        bottom: '0 !important',
        // Hide native scrollbar completely
        scrollbarWidth: 'none',
        '-ms-overflow-style': 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      },
    },
  },
  scrollBarTrackY: {
    backgroundColor: 'rgba(255,255,255,0)',
    boxSizing: 'border-box',
    bottom: 0,
    top: 0,
    borderRadius: '0',
    width: ['6px', '!important'],
    // Position based on text direction
    '[dir="ltr"] &': {
      right: 0,
      left: 'auto',
    },
    '[dir="rtl"] &': {
      left: 0,
      right: 'auto',
    },
  },
  scrollBarThumbY: {
    cursor: 'pointer',
    borderRadius: '0',
    backgroundColor: 'rgba(0,0,0,.4)',
    width: ['6px', '!important'],
    margin: 'auto',
  },
});

type ScrollbarProps = {
  children: React.ReactNode;
  renderBoxProps?: BoxProps;
};

export function Scrollbar({ children, renderBoxProps = {} }: ScrollbarProps) {
  const classes = useStyles();

  return (
    <ReactScrollbar
      className={classes.scrollbarContainer}
      renderView={props => <Box {...props} {...renderBoxProps} />}
      renderTrackVertical={props => (
        <div {...props} className={classes.scrollBarTrackY} />
      )}
      renderThumbVertical={props => (
        <div {...props} className={classes.scrollBarThumbY} />
      )}
      thumbSize={300}
    >
      <div className="scrollbarContent">{children}</div>
    </ReactScrollbar>
  );
}
